<script>
import defaultProfileImage from '../../images/default_profile.png'

export default {
  props: ['imageUrl'],
  data() {
    return {
    }
  },
  computed: {
    profileImage() {
      return this.imageUrl || defaultProfileImage
    }
  },
  methods: {
    openImageInViewer() {
      if (!this.$viewerApi) {
        return
      }

      this.$viewerApi({images: [this.profileImage]})
    }
  }
}
</script>
<template>
  <img class="profile-image" :src="profileImage" @click="openImageInViewer"/>
</template>
<style scoped lang="scss">
  .profile-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;

    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;

    &:hover {
      cursor: pointer;
    }
  }
</style>
